export default defineNuxtPlugin(() => {
  return {
    provide: {
      dummyModel: '',
    },
  }
})
